/**
 * DS Breed Select – Self-Segmentation Landing Page
 * Lets legacy subscribers choose their breed and re-subscribe with breed tag.
 * Uses redirect:'manual' — opaqueredirect = success, else parse HTML for errors.
 * Both success AND duplicate show same positive message (tags are additive).
 * V1.0 – 2026-03-03
 */
(function() {
  'use strict';

  var container = document.querySelector('[data-ds-breed-select]');
  if (!container) return;

  var breedBtns = container.querySelectorAll('[data-ds-breed]');
  var tagsInput = container.querySelector('[data-ds-breed-tags]');
  var formWrap = container.querySelector('[data-ds-breed-form]');
  var emailInput = container.querySelector('[data-ds-breed-email]');
  var submitBtn = container.querySelector('[data-ds-breed-submit]');
  var btnText = container.querySelector('[data-ds-breed-btn-text]');
  var feedback = container.querySelector('[data-ds-breed-feedback]');
  var formEl = container.querySelector('form');

  if (!formEl || !emailInput || !submitBtn || !tagsInput) return;

  var selectedBreed = '';
  var selectedBreedName = '';

  // --- Breed Selection ---

  breedBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      // Deselect all
      breedBtns.forEach(function(b) {
        b.classList.remove('ds-breed-select__breed--active');
        b.setAttribute('aria-checked', 'false');
      });

      // Select this one
      btn.classList.add('ds-breed-select__breed--active');
      btn.setAttribute('aria-checked', 'true');

      selectedBreed = btn.getAttribute('data-ds-breed');
      selectedBreedName = btn.getAttribute('data-breed-name');

      // Set hidden tags
      tagsInput.value = 'breed:' + selectedBreed + ',self-segmentation';

      // Show form
      formWrap.classList.add('ds-breed-select__form--visible');
      emailInput.focus();

      // Clear previous feedback
      showFeedback('', '');

      // GA4: breed selected
      pushGA4('ds_breed_select', { ds_breed: selectedBreed });
    });

    // Keyboard: Enter/Space to select
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        btn.click();
      }
    });
  });

  // Arrow key navigation within radiogroup
  var breedGroup = container.querySelector('[data-ds-breed-group]');
  if (breedGroup) {
    breedGroup.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        moveFocus(1);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        moveFocus(-1);
      }
    });
  }

  function moveFocus(direction) {
    var btns = Array.prototype.slice.call(breedBtns);
    var current = btns.indexOf(document.activeElement);
    if (current === -1) current = 0;
    var next = (current + direction + btns.length) % btns.length;
    btns[next].focus();
    btns[next].click();
  }

  // --- Form Submission ---

  formEl.addEventListener('submit', function(e) {
    e.preventDefault();

    if (!selectedBreed) {
      showFeedback('Bitte wähle zuerst eine Rasse aus.', 'error');
      return;
    }

    var email = emailInput.value.trim();
    if (!email || !emailInput.validity.valid) {
      showFeedback('Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
      return;
    }

    submitBtn.disabled = true;
    btnText.textContent = '';
    var spinner = document.createElement('span');
    spinner.className = 'ds-breed-select__spinner';
    submitBtn.appendChild(spinner);

    fetch(formEl.action, {
      method: 'POST',
      body: new URLSearchParams(new FormData(formEl)),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      redirect: 'manual'
    })
    .then(function(response) {
      removeSpinner();

      if (response.type === 'opaqueredirect') {
        handleSuccess();
        return;
      }

      return response.text().then(function(html) {
        var lower = html.toLowerCase();
        if (lower.indexOf('bereits') !== -1 || lower.indexOf('already') !== -1) {
          // Duplicate = same success message (tags are additive)
          handleSuccess();
        } else {
          handleError();
        }
      });
    })
    .catch(function() {
      removeSpinner();
      handleError();
    });
  });

  // --- State Handlers ---

  function handleSuccess() {
    submitBtn.classList.add('ds-breed-select__btn--success');
    btnText.textContent = 'Gespeichert';
    emailInput.disabled = true;
    disableBreedButtons();
    showFeedback('Perfekt! Du bekommst ab jetzt Inhalte für ' + selectedBreedName + '-Besitzer.', 'success');
    pushGA4('ds_breed_submit', { ds_breed: selectedBreed, ds_source: 'self-segmentation' });
  }

  function handleError() {
    submitBtn.disabled = false;
    btnText.textContent = 'Bestätigen';
    showFeedback('Etwas ist schiefgelaufen. Bitte versuche es erneut.', 'error');
  }

  // --- Helpers ---

  function disableBreedButtons() {
    breedBtns.forEach(function(btn) {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.6';
      btn.setAttribute('tabindex', '-1');
    });
  }

  function removeSpinner() {
    var s = submitBtn.querySelector('.ds-breed-select__spinner');
    if (s) s.remove();
  }

  function showFeedback(msg, type) {
    if (!msg) {
      feedback.textContent = '';
      feedback.className = 'ds-breed-select__feedback';
      return;
    }
    feedback.textContent = msg;
    feedback.className = 'ds-breed-select__feedback ds-breed-select__feedback--' + type;
  }

  function pushGA4(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));
  }

  // --- URL Pre-fill (optional, from email campaign link) ---

  var urlParams = new URLSearchParams(window.location.search);
  var prefillEmail = urlParams.get('email');
  if (prefillEmail) {
    emailInput.value = prefillEmail;
  }
})();
